"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class WhenCondition {
    constructor(expression) {
        this.expression = expression;
    }
    shouldDoValidation(input) {
        return this.expression(input);
    }
}
exports.WhenCondition = WhenCondition;
//# sourceMappingURL=WhenCondition.js.map